<template>
  <header class="relative z-20">
    <div
      class="container"
      v-if="currentPath != '/admin/airport/toulouse/blagnac/agency/checkcode/control'"
    >
      <div class="header-content">
        <router-link to="/"
          ><img src="@/assets/images/top.png" alt="top" class="w-full m-auto"
        /></router-link>
        <router-link to="/"
          ><img
            src="@/assets/images/slogan.png"
            alt="solgan"
            class="w-[70%] absolute top-[10%] left-1/2 -translate-x-1/2 m-auto"
        /></router-link>
        <LanguageSelector class="absolute top-3 right-3" />
        <div
          class="absolute top-[55%] text-[5vw] sm:text-[35px] w-full text-center font-semibold right-0 text-white"
          v-html="$t('header.eventPeriod')"
        ></div>
      </div>
    </div>

    <div
      class="container"
      v-else
    >
      <div class="header-content relative">
        <router-link to="/"
          ><img src="@/assets/images/top2.png" alt="top" class="w-full m-auto"
        /></router-link>
        <router-link to="/"
          ><img
            src="@/assets/images/slogan.png"
            alt="solgan"
            class="w-[30%] sm:w-[35%] absolute top-[5%] z-50 left-[5%] "
        /></router-link>
        <LanguageSelector class="absolute top-3 right-3" />
        <div
          class="absolute top-[40%] sm:top-[45%] text-[3vw] sm:text-[25px] w-full text-left pl-[5%] font-semibold right-0 text-white"
          v-html="$t('header.eventPeriod')"
        ></div>
      </div>
    </div>

  </header>
</template>

<script>
import LanguageSelector from "./LanguageSelector.vue";

export default {
  name: "HeaderView",
  components: {
    LanguageSelector,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped>
.header-content {
  @apply flex justify-between items-center;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
